var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-relative gl-mr-3 gl-rounded-full",class:{
    [_vm.iconClassNameText]: !_vm.isLoading,
    [`mr-widget-status-icon-level-${_vm.level}`]: !_vm.isLoading,
    'gl-flex gl-h-6 gl-w-6 gl-items-center gl-justify-center': _vm.level === 1,
  }},[(_vm.isLoading)?_c('gl-loading-icon',{attrs:{"size":"sm","inline":""}}):_c('gl-icon',{staticClass:"gl-relative gl-z-1",attrs:{"name":_vm.$options.EXTENSION_ICON_NAMES[_vm.iconName],"size":12,"aria-label":_vm.iconAriaLabel,"data-testid":`status-${_vm.iconName}-icon`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }